var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.classStyle,attrs:{"type":_vm.inputType,"readonly":"","disabled":_vm.classStyle==='disabled-btn'},domProps:{"value":_vm.text},on:{"click":function($event){return _vm.btnClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }